// Preset group page background themes -- owners/admins/moderators pick one
// to personalize their group's page (GroupHeader.jsx). Deliberately a
// curated set (flat gradients + illustrated banner images), not freeform
// uploads: no storage/moderation surface to build, and every option stays
// on-brand by construction. "nebula" matches the real homepage palette
// (#09090f bg + violet/indigo/blue, see credibilityTiers.js's own palette
// note) and is the default for any group that hasn't picked one.
//
// 2026-07-19: added 4 illustrated banner options alongside the original 6
// flat gradients -- each theme now carries a `type` ("gradient" | "image")
// so consumers can branch once, in groupBackgroundStyle() below, instead
// of every call site re-deriving how to render a given theme.
export const GROUP_BACKGROUND_THEMES = {
  nebula: {
    id: "nebula",
    name: "Nebula",
    type: "gradient",
    gradient: "linear-gradient(135deg, #a78bfa 0%, #818cf8 50%, #60a5fa 100%)",
  },
  bullish: {
    id: "bullish",
    name: "Bullish Green",
    type: "gradient",
    gradient: "linear-gradient(135deg, #34d399 0%, #10b981 50%, #0d9488 100%)",
  },
  solar: {
    id: "solar",
    name: "Solar Flare",
    type: "gradient",
    gradient: "linear-gradient(135deg, #fbbf24 0%, #f97316 50%, #ea580c 100%)",
  },
  midnight: {
    id: "midnight",
    name: "Midnight",
    type: "gradient",
    gradient: "linear-gradient(135deg, #1e293b 0%, #0f172a 50%, #09090f 100%)",
  },
  rose: {
    id: "rose",
    name: "Rose Quartz",
    type: "gradient",
    gradient: "linear-gradient(135deg, #fda4af 0%, #f472b6 50%, #c084fc 100%)",
  },
  cyber: {
    id: "cyber",
    name: "Cyber Blue",
    type: "gradient",
    gradient: "linear-gradient(135deg, #22d3ee 0%, #38bdf8 50%, #6366f1 100%)",
  },
  skyline: {
    id: "skyline",
    name: "Skyline Rally",
    type: "image",
    image: "/group-banners/banner_skyline.svg",
  },
  orbit: {
    id: "orbit",
    name: "Orbit",
    type: "image",
    image: "/group-banners/banner_orbit.svg",
  },
  bullmarket: {
    id: "bullmarket",
    name: "Bull Market",
    type: "image",
    image: "/group-banners/banner_bullmarket.svg",
  },
  constellation: {
    id: "constellation",
    name: "Constellation",
    type: "image",
    image: "/group-banners/banner_constellation.svg",
  },
};

export const DEFAULT_GROUP_BACKGROUND_THEME = "nebula";

export const groupBackgroundTheme = (id) =>
  GROUP_BACKGROUND_THEMES[id] || GROUP_BACKGROUND_THEMES[DEFAULT_GROUP_BACKGROUND_THEME];

// One place that knows how to turn a theme into an inline style object --
// GroupHeader.jsx and GroupBackgroundThemePicker.jsx both just spread this
// rather than each re-implementing the gradient-vs-image branch.
export const groupBackgroundStyle = (id) => {
  const theme = groupBackgroundTheme(id);
  if (theme.type === "image") {
    return {
      backgroundImage: `url(${theme.image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    };
  }
  return { background: theme.gradient };
};
